import { quotePdfFilename } from '../quote/quotePdfViewModel';
import { authHeader, salesApiBaseUrl } from './authHeader';
// Save a blob to disk via a transient object URL. Isolated so the network call
// above stays free of DOM concerns.
const triggerBrowserDownload = (blob, filename) => {
    const url = URL.createObjectURL(blob);
    const anchor = document.createElement('a');
    anchor.href = url;
    anchor.download = filename;
    document.body.appendChild(anchor);
    anchor.click();
    document.body.removeChild(anchor);
    URL.revokeObjectURL(url);
};
// POST the assembled quote view model to the authed sales-api PDF route and save
// the returned document. The route renders the PDF server-side and stores
// nothing; this only ships the view model and downloads the response.
export const downloadQuotePdf = async (viewModel) => {
    const auth = await authHeader();
    const response = await fetch(`${salesApiBaseUrl()}/quotes/pdf`, {
        method: 'POST',
        headers: {
            ...auth,
            'Content-Type': 'application/json',
            'Accept': 'application/pdf'
        },
        body: JSON.stringify(viewModel)
    });
    if (!response.ok) {
        throw new Error(`Quote PDF request failed with status ${response.status}`);
    }
    triggerBrowserDownload(await response.blob(), quotePdfFilename(viewModel));
};
